import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { DuplicateUserDTO } from '#app/api';

export interface DuplicatesState {
    items: DuplicateUserDTO[];
    lastFetchedAt: string | null;
}

const initialState: DuplicatesState = {
    items: [],
    lastFetchedAt: null,
};

export const duplicatesSlice = createSlice({
    name: 'duplicates',
    initialState,
    reducers: {
        setDuplicates(state, action: PayloadAction<{ items: DuplicateUserDTO[]; fetchedAt: string }>) {
            state.items = action.payload.items;
            state.lastFetchedAt = action.payload.fetchedAt;
        },
        clearDuplicates(state) {
            state.items = [];
            state.lastFetchedAt = null;
        },
    },
});

export const { setDuplicates, clearDuplicates } = duplicatesSlice.actions;

export default duplicatesSlice.reducer;

